/* eslint-disable no-plusplus */
/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import 'sal.js/dist/sal.css';
import React, { useState, useRef, useEffect } from 'react';
import sal from 'sal.js';

import CtaCard from 'components/shared/cta-card';

const AllNews = ({ blok }) => {
  const ITEMS_TO_SHOW = 10;
  const [activeNews, setActiveNews] = useState([]);
  const [visibleNews, setVisibleNews] = useState([]);
  const [itemsToShow, setItemsToShow] = useState(ITEMS_TO_SHOW);
  const newsContainerRef = useRef(null);

  const handleScroll = () => {
    if (
      newsContainerRef.current &&
      newsContainerRef.current.getBoundingClientRect().bottom <= window.innerHeight + 50
    ) {
      setItemsToShow((prevItems) => prevItems + ITEMS_TO_SHOW);
    }
  };

  useEffect(() => {
    const data = blok?.news.flatMap((item) => [{ ...item.content, full_slug: item.full_slug }]);
    setActiveNews(data);
  }, [blok?.news]);

  useEffect(() => {
    setVisibleNews(activeNews.slice(0, itemsToShow));
  }, [activeNews, itemsToShow]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (visibleNews.length > ITEMS_TO_SHOW) {
      sal({ threshold: 0.25 });
    }
  }, [visibleNews.length]);

  return (
    <div
      className="container grid grid-cols-2 gap-5 py-7 lg:relative lg:grid-cols-3 lg:py-8 xl:gap-8 xl:py-10"
      ref={newsContainerRef}
    >
      {activeNews && (
        <>
          {visibleNews.map((news, index) => {
            const index1 = index + 1;
            let gridClass = '';
            let aspectRatioClass = '';
            let containerClass = '';
            let figCaptionClass = '';
            let mediaWrapperClass = '';

            switch (index1 % ITEMS_TO_SHOW) {
              case 1:
                aspectRatioClass = 'mobile:aspect-[520/320]';
                figCaptionClass = 'mobile:flex-1';
                mediaWrapperClass = 'mobile:!overflow-visible lg:aspect-[520/320]';
                break;
              case 2:
                gridClass = 'lg:row-span-2';
                aspectRatioClass = 'mobile:aspect-[520/320]';
                figCaptionClass = 'mobile:flex-1';
                mediaWrapperClass = 'mobile:!overflow-visible lg:aspect-[520/820]';
                break;
              case 3:
                gridClass = 'mobile:row-span-2';
                aspectRatioClass = 'mobile:aspect-[520/820]';
                mediaWrapperClass = 'lg:aspect-[520/320]';
                break;
              case 4:
                gridClass = 'mobile:row-span-2 mobile:self-start';
                mediaWrapperClass = 'lg:aspect-[520/320]';
                break;
              case 5:
                gridClass = 'col-span-2';
                break;
              case 6:
                gridClass = 'mobile:col-span-2 lg:self-end';
                containerClass = 'mobile:w-1/2 mobile:box-border';
                break;
              case 7:
                figCaptionClass = 'mobile:flex-1';
                mediaWrapperClass = 'mobile:!overflow-visible lg:aspect-[520/320]';
                break;
              case 8:
                gridClass = 'lg:row-span-2 lg:self-start';
                figCaptionClass = 'mobile:flex-1';
                mediaWrapperClass = 'mobile:!overflow-visible lg:aspect-[520/320]';
                break;
              case 9:
                gridClass = 'mobile:row-span-2 mobile:self-start lg:row-span-2';
                mediaWrapperClass = 'lg:aspect-[520/820]';
                break;
              case 0:
                gridClass = 'mobile:row-span-2';
                aspectRatioClass = 'mobile:aspect-[520/820]';
                mediaWrapperClass = 'lg:aspect-[520/320]x';
                break;
              default:
                aspectRatioClass = 'aspect-[520/320]';
                break;
            }

            return (
              <div key={`${news.name}-${index}`} className={gridClass}>
                <CtaCard
                  data={news}
                  slug={news.full_slug}
                  aspectRatioClass={aspectRatioClass}
                  containerClass={containerClass}
                  figCaptionClass={`${figCaptionClass} lg:line-clamp-2 lg:flex-[0_0_100px] xl:flex-[0_0_145px]`}
                  mediaWrapperClass={`${mediaWrapperClass}`}
                  isAnimated
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default AllNews;

AllNews.propTypes = {
  blok: PropTypes.object.isRequired,
};
